import BaseApi from 'api/BaseApi';
import { ApplicationStatusType } from './ApplicationsApi';

export interface IApplicationStatus {
  id: string;
  name: string;
  type: ApplicationStatusType;
  color: string;
}

export interface IFindApplicationStatusParams {
  productIds?: string[];
  types?: ApplicationStatusType[];
}

export interface IApplicationStatusesApi {
  find(params: IFindApplicationStatusParams): Promise<IApplicationStatus[]>;
}

export default class ApplicationStatusesApi extends BaseApi implements IApplicationStatusesApi {
  public async find(params: IFindApplicationStatusParams): Promise<IApplicationStatus[]> {
    const urlSearchParams = new URLSearchParams();

    params.productIds?.forEach((productId) => {
      urlSearchParams.append('productId', productId);
    });

    params.types?.forEach((type) => {
      urlSearchParams.append('type', type);
    });

    return this.fetch( `/application-statuses?${urlSearchParams}`);
  }
}
